import { defineMessages } from "react-intl";
const messages = defineMessages({
    userSettingsTitle: {
        id: "app.userSettings.title.text",
        defaultMessage: "User Settings",
    },
    userSettingsProfileTitle: {
        id: "app.userSettings.profileTab.title.text",
        defaultMessage: "Profile",
    },
    userSettingsEmailNotificationsTitle: {
        id: "app.userSettings.emailNotifications.title.text",
        defaultMessage: "Email Notifications",
    },
});
export default messages;
